import { useOutletContext } from 'react-router-dom';

/**
 * What the Statements shell hands to whichever tab is open.
 *
 * **The rule for every shell range, stated once here because this is the second
 * shell to carry one and the mistake it prevents is silent:** a tab that
 * reports *at a date* takes the range's `toDate` and ignores `fromDate` — a
 * balance is cumulative, so "assets at 31 March" is an answer and "assets from
 * January to March" is not. A tab that reports *over a period* takes both.
 * Wiring a period range into an as-of screen does not fail; it reports the
 * wrong date and balances perfectly while doing so.
 *
 * Balance Sheet is as-of. Profit & Loss is a period. Same split as Books, where
 * Chart of Accounts and Trial Balance take the end while Journal and VAT take
 * the whole window.
 */
export type StatementsOutletContext = {
    /** ISO `YYYY-MM-DD`. */
    fromDate: string;
    toDate: string;
};

/** The shell's range, or an empty one when a tab is rendered outside it. */
const NO_RANGE: StatementsOutletContext = { fromDate: '', toDate: '' };

export const useStatementsRange = (): StatementsOutletContext =>
    useOutletContext<StatementsOutletContext | null>() ?? NO_RANGE;
